/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import Formulario_Adicional from "../Formularios/Formulario_Adicional";
import {theme} from "../../Tema";
import {subirMultiplesImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirMultiplesImagenHostingFile";

const Dialogo_Adicionales = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrar, funcionDos: realizado})
    const {Cargador, abrirCargador, setDetener} = useLoaders({logo: logo})


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        abrirCargador('Guardando Datos')
        entidad.fecha = new Date().getTime()
        let resultado = await subirImagenHostingFile(entidad.img)
        let resultadoImgs = await subirMultiplesImagenHostingFile(entidad.imgs)
        entidad.img = resultado.data
        entidad.imgs = resultadoImgs.data
        nuevoAviso({aviso: 'Imagenes subida'})

        let dox = await guardarDoc('adicionales', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('adicionales', datos.id)
        terminar({aviso: 'Adicional borrado'})
    }
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Adicional props={props}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        sx={{color: theme.palette.primary.main, px: 1}}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }


        </Grid2>
    )

}
export default Dialogo_Adicionales